import { PileIdHandler } from '../card/pile-id-handler';
import { Command } from './command';
import { sha256 } from 'js-sha256';
import { MoveCommand } from './move-command';
import { AutoFinishMoveCommand } from './auto-finish-move-command';
import { DrawDeckMoveCommand } from './draw-deck-move-command';
import { BackToDeckMoveCommand } from './back-to-deck-move-command';
import { UndoCommand } from './undo-command';

export class CommandListSerializer {
  public static getHash(commandList: Command[]): string {
    const output = CommandListSerializer.serializedCommands(commandList);
    return CommandListSerializer.computeHash(output);
  }

  public static serializedCommands(commandList: Command[]): string {
    return commandList.map((command) => command.serializeToString()).join('\n');
  }

  public static computeHash(output: string): string {
    return sha256.create().update(output).hex();
  }

  public static moveToCommand(move: string): Command | undefined {
    type CmdStr = {
      command?: string;
      moveFrom?: string;
      moveTo?: string;
    };

    function parseMove(input: string): CmdStr {
      const parts = input.split(' ');
      const cmdStr: CmdStr = {};

      if (parts.length > 0) {
        cmdStr.command = parts[0];
      }

      if (parts.length > 1) {
        cmdStr.moveFrom = parts[1];
      }

      if (parts.length > 2) {
        cmdStr.moveTo = parts[2];
      }

      return cmdStr;
    }

    const cmdStr = parseMove(move);
    if (cmdStr.command === undefined) {
      throw new Error('Invalid move');
    }
    switch (cmdStr.command) {
      case 'move':
        if (cmdStr.moveFrom !== undefined && cmdStr.moveTo !== undefined) {
          return new MoveCommand(cmdStr.moveFrom, PileIdHandler.getPileIDFromString(cmdStr.moveTo));
        }
        break;
      case 'autofinish':
        if (cmdStr.moveFrom !== undefined && cmdStr.moveTo !== undefined) {
          return new AutoFinishMoveCommand(
            cmdStr.moveFrom,
            PileIdHandler.getPileIDFromString(cmdStr.moveTo),
          );
        }
        break;
      case 'drawdeck':
        return new DrawDeckMoveCommand();
      case 'backdeck':
        return new BackToDeckMoveCommand();
      case 'undo':
        return new UndoCommand();
      default:
        throw new Error('Invalid move');
    }

    return undefined;
  }
}
